<div class="row">
  <div class="col text-center">
    <a routerLink="/competicionesFMP" routerLinkActive="active"><img src="/assets/imgs/ic_fmp.png" width="100" height="100" alt="" align="center"></a>
  </div>
  <div class="col text-center">
    <a routerLink="/entrenamientos" routerLinkActive="active"><img src="/assets/imgs/ic_horarios.png" width="100" height="100" alt="" align="center"></a>
  </div>
</div>
<div class="row">
  <div class="col text-center">
    <a routerLink="/competicionesFMP" routerLinkActive="active">COMPETICIONES</a>
  </div>
  <div class="col text-center">
    <a routerLink="/entrenamientos" routerLinkActive="active">ENTRENAMIENTOS</a>
  </div>
</div>
<div class="row">
  <div class="col text-center">
    <a routerLink="/agenda" routerLinkActive="active"><img src="/assets/imgs/ic_calendar.png" width="100" height="100" alt="" align="center"></a>
  </div>
  <div class="col text-center">
    <a href="#" onclick="window.open('mailto:correo@chpaluche.es', '_self');"><img src="/assets/imgs/ic_email.png" width="100" height="100" alt="" align="center"></a>
  </div>
</div>
<div class="row">
  <div class="col text-center">
    <a routerLink="/agenda" routerLinkActive="active">AGENDA</a>
  </div>
  <div class="col text-center">
    <a href="#" onclick="window.open('mailto:correo@chpaluche.es', '_self');">CONTACTO</a>
  </div>
</div>